import React, { forwardRef } from 'react';
import Image from '../image'; // @ts-ignore
// import mergeRefs from 'react-merge-refs';

import stickIcon from '../../../assets/images/xr/icons/stick-icon.png';

type TStickProps = {};

const Stick = forwardRef((props: TStickProps, ref) => {
  return (
    // @ts-ignore TODO: fix this
    <group {...props} ref={ref}>
      <Image src={stickIcon} width={0.04} height={0.04} position={[0.01, -0.01, 0.5]} renderOrder={1000} />
    </group>
  );
});

export default Stick;
